<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<div v-if="invoicetype == 'outputinvoice'" class="flex full" style="flex-direction: column;position: relative;overflow: hidden;">
					<div style="width: 100%;height: 80px;">
						<el-steps :active="step" finish-status="success" align-center>
							<el-step title="选择时间" :description="datetext"></el-step>
							<el-step title="关联存货"></el-step>
							<el-step title="生成单据"></el-step>
						</el-steps>
					</div>
					<div style="flex: 1;position: relative;">
						<div class="full" v-show="step==0">
							<el-calendar v-model="date">
								<template slot="dateCell" slot-scope="{date, data}">
									<p :class="data.isSelected ? 'is-selected' : ''">
										{{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}}
									</p>
									<div v-if="statics[data.day.split('-').slice(1).join('-')]">
										<el-tag  v-if="statics[data.day.split('-').slice(1).join('-')] == 1"  type="success" size="mini">已生成</el-tag>
										<el-tag  v-else size="mini">部分生成</el-tag>
									</div>									
									<el-tag  v-else type="danger" size="mini">未生成</el-tag>
								</template>
							</el-calendar>
						</div>
						<div class="full" v-show="step==1">
							<initoutputinvoiceorder :date="date" ref="initoutputinvoiceorder" />
						</div>
						<div class="full" v-show="step==2">
							<createorder-output :date="date" ref="createorderOutput" />
						</div>
					</div>
				</div>
				
				<div v-else class="flex full" style="flex-direction: column;position: relative;overflow: hidden;">
					<div style="width: 100%;height: 80px;">
						<el-steps :active="step" finish-status="success" align-center>
							<el-step title="相关发票" :description="datetext"></el-step>
							<el-step title="关联存货"></el-step>
							<el-step title="生成单据"></el-step>
						</el-steps>
					</div>
					<div style="flex: 1;position: relative;">
						<div class="full" v-show="step==0">
							<invoicelist :store="store" :data="data" ref="invoicelist" />
						</div>
						<div class="full" v-show="step==1">
							<initinputinvoiceorder :store="store" :data="data" ref="initinputinvoiceorder" />
						</div>
						<div class="full" v-show="step==2">
							<createorder-input :store="store" ref="createorderInput" />
						</div>
					</div>
					
				</div>
				
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button v-if="step!=0" status="primary" content="上一步" @click="pre"></vxe-button>
				<vxe-button v-if="step!=2" status="primary" content="下一步" @click="next"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import initoutputinvoiceorder from './initoutputinvoiceorder/index.vue'
	import invoicelist from './invoicelist/index.vue'
	import initinputinvoiceorder from './initinputinvoiceorder/index.vue'

	import createorderOutput from './createorder/output.vue'
	import createorderInput from './createorder/input.vue'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			invoicetype: {
				default: () => {
					return 'outputinvoice'
				}
			},
		},
		data() {
			return {
				store:{},
				step: 0,
				invoicedata:[],
				tab:[],
				goodsUids:[],
				currentrow:null,
				modal_model: false,
				modal_title: '生成亿企赢单据',
				modal_width: 1200,
				modal_height: 800,
				date: null,
				list_footerField:[
					{field:'price',toFixed:6},
					{field:'taxprice',toFixed:6},
					{field:'totalPrice',toFixed:6},
				],
				statics:{}
			}
		},
		watch: {
			date() {
				this.getorderyqdzorderstatics()
			},
		},
		computed: {
			device() {
				return window.systemMethods.device()
			},
			datetext(){
				if(this.date){
					return window.systemMethods.timestampToDate(new Date(this.date).getTime(),true)
				}
				return null
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			pre() {
				if(this.step>0){
					this.step--
				}
				
			},
			next() {
				if(this.invoicetype == 'outputinvoice'){
					if(!this.date){
						this.$message.error('请选择时间')
						return
					}
					if(this.step < 2){
						if(this.step==1){
							let obj = this.$refs.initoutputinvoiceorder.valid()
							if(obj){
								this.$message.error('存货名称未配置')
								return
							}						
						}						
						this.step++
						if(this.step==1){
							this.$refs.initoutputinvoiceorder.customreload()
						}
						if(this.step==2){
							this.$refs.createorderOutput.customreload()
						}
					}
				}
				if(this.invoicetype == 'inputinvoice'){
					if(this.step==1){
						let obj = this.$refs.initinputinvoiceorder.valid()
						if(obj){
							this.$message.error('存货名称未配置')
							return
						}
					}
					if(this.step < 2){
						this.step++
						if(this.step==1){
							this.$refs.initinputinvoiceorder.list_init()
						}
						if(this.step==2){
							this.$refs.createorderInput.list_init()
							this.$nextTick(()=>{
								this.$refs.createorderInput.customreload()
							})
							
						}
					}

				}
			},
			modal_show() {
				this.date = null
				this.step = 0
				this.getorderyqdzorderstatics()
				this.modal_model = true
			},
			submit() {

				//this.init()
			},
			reset() {
				//this.init()
			},
			getorderyqdzorderstatics(){
				this.$api.invoice.getorderyqdzorderstatics({
					date:new Date(this.date).getTime()/1000
				}).then((res)=>{
					this.statics = res
				})
			}
		},
		components: {
			initoutputinvoiceorder,
			initinputinvoiceorder,
			invoicelist,
			createorderOutput,
			createorderInput
		}
	}
</script>